import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function consoleRelatedList(
  console_id: string,
  query?: QueryType,
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `admin/console/${console_id}/related/list${queryString}`,
  );
}

export async function consoleRelatedConsoleList(
  console_id: string,
  query?: QueryType,
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `admin/console/related/${console_id}/console/list${queryString}`,
  );
}

export async function consoleRelatedListId(console_id: string) {
  return await clientAxios.get(`admin/console/${console_id}/related/list/id`);
}

export async function consoleRelatedListOwnerIdByConsole(console_id: string) {
  return await clientAxios.get(`admin/console/related/${console_id}/list/id`);
}

export async function consoleRelatedGet(item_id: string) {
  return await clientAxios.get(`admin/console/related/${item_id}/show`);
}

export async function consoleRelatedCreate(
  console_id: string,
  payload: Partial<any>,
) {
  return await clientAxios.post(
    `admin/console/${console_id}/related/create`,
    payload,
  );
}

export async function consoleRelatedDelete(item_id: string) {
  return await clientAxios.del(`admin/console/related/${item_id}/delete`);
}
